import React, { useEffect, useRef } from "react";

export default function AudioPlayer({ src, autoPlay }) {
    const audioRef = useRef();
  
    useEffect(() => {
      if (src) {
        audioRef.current.src = src;
        audioRef.current.play();
      } else {
        audioRef.current.pause();
      }
    }, [src]);
  
    return <audio ref={audioRef} autoPlay={autoPlay} controls id="audioPlayer"/>;
  };  